import { DSCBMissed, DSMissedProps } from 'shared-definitions/types'
import { ApiContentBlockMissedProps, ApiMissedProps } from 'data-source/types.wp'

interface MissedOpts {
  codecGetMissedProps: (raw: ApiMissedProps) => DSMissedProps
}

export function cbMissed(input: ApiContentBlockMissedProps, opts: MissedOpts): DSCBMissed {
  return {
    resource: 'cb-missed',
    title: input.title,
    subtitle: input.subtitle,
    ...opts.codecGetMissedProps(input.content),
  }
}
